// extracted by mini-css-extract-plugin
export default {"percentageBar":"Average_percentageBar__FmUKm","text":"Average_text__Gqjsv"};